import axios from "axios";
import { getApiConfig } from "../../apiConfig";

export async function PostIncident(incident) {
  try {
    const apiConfig = await getApiConfig();
    const req = `${apiConfig.BASE_URL}incident`;

    const file = incident.file
      ? {
        name: incident.file.fileName,
        mimeType: incident.file.mimeType,
        fileData: incident.file.base64Content,
        modifiedBy: "ea1e3cb5-8b39-4f3b-a938-b9070d9d9746",
      }
      : null;

    const customResponse = incident.customResponse ? incident.customResponse : null;

    const incidentPost = {
      incident: {
        audio: incident.audio ? incident.audio : null,
        incidentCategory: incident.category,
        anonymousIncident: incident.incidentType,
        userName: incident.name ? incident.name : null,
        title: incident.title,
        description: incident.description,
        company: incident.company,
        workPlace: incident.workPlace ? incident.workPlace : null,
        // responsibleKey: incident.responsibleKey,
        // responsible: incident.responsible,
        mail: incident.mail ? incident.mail : null,
        informantType: incident.informantType ? incident.informantType : null,
        incidentDate: incident.incidentDate ? incident.incidentDate : null,
      },
      file: file,
      customResponse: customResponse,
    };

    const response = await axios.post(req, incidentPost, apiConfig.HEADERS_CONFIG, {});
    
    return response.data;
  } catch (error) {
    // Manejar el error
    throw error;
  }
}
